import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Entity, CacheService } from '@mapfre-tech/amap3';
import { Observable, throwError, of, Subject } from "rxjs";
import { map, catchError } from "rxjs/operators";
import moment from 'moment';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Injectable({
   providedIn: "root"
})
export class EntityService {

   className = 'EntityService'

   memoryCache = {
      "entitiesBySO": {
         "data": null,
         "lastReqDate": null
      },
      "entitiesByCountryId": {
         "data": null,
         "lastReqDate": null
      }
   }

   constructor(private http: HttpClient, private router: Router, private cacheService: CacheService) { }

   getAllEntities(showAll = false): Observable<Entity[]> {
      const cache = true;
      const params: any = {};
      params.showAll = showAll;
      const cacheKey = "allEntities"+"_"+showAll.toString()

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         const observable = this.http.get<Entity[]>(environment.base_URL + "/entities", { params }).pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getEntitiesByBusinessUnit(unitBusinessID: number, showAll = false): Observable<Entity[]> {
      const params: any = {};
      params.showAll = showAll;
      params.unitBusiness = unitBusinessID;
      return this.http.get<Entity[]>(environment.base_URL + '/entities', { params });
   }

   getEntitiesBySO(id, cache = true): Observable<Entity[]> {
      const cacheKey = "entitiesBySO"

      if (cache && this.cacheService.canUseCache(cacheKey, [id.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [id.toString()]);
      } else {
         const observable = this.http.get<Entity[]>(environment.base_URL + `/entities/organizational/${id}`).pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey, [id.toString()])
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey, [id.toString()] );
         return observable;
      }
   }

   getEntitiesByCountriesId(countriesIds, cache = true): any {
      const params = {
         countriesIdsList: countriesIds.join(',')
      }
      const cacheKey = "entitiesByCountryId"

      if (cache && this.cacheService.canUseCache(cacheKey, [countriesIds.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [countriesIds.toString()]);
      } else {
         const observable = this.http.get<Entity[]>(environment.base_URL + "/entities", { params }).pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey, [countriesIds.toString()])
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey, [countriesIds.toString()] );
         return observable;
      }
   }   

   getAllEntitiesNoAutoID(): Observable<Entity[]> {
      return this.http
         .get<Entity[]>(environment.base_URL + "/entities")

   }

   removeById(array) {
      array.forEach(element => {
         delete element.id;
      });
      return array;
   }

   newEntity(entity) {
      return this.http.post(environment.base_URL + "/entities", entity);
   }

   updateEntity(entity, id) {
      return this.http.put(environment.base_URL + `/entities/${id}`, entity);
   }

   deleteEntity(id: number) {
      return this.http.delete(environment.base_URL + `/entities/${id}`);
   }

   canUseCache(key) {
      const oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
      let canUse = false;
      if (moment().diff(oldDate, 'minutes') <= 1) {
         canUse = true;
      }
      return canUse;
   }

   updateCacheData(data, key) {
      _.set(this.memoryCache, `${key}.data`, data);

      _.get(this.memoryCache, `${key}._subject`).next(data);
   }

   updateCacheReq(key) {
      const _subject = new Subject<any>();
      const observer = _subject.asObservable();
      _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
   }


}
